import { render, staticRenderFns } from "./Deploy.vue?vue&type=template&id=1f2c0f1a&"
import script from "./Deploy.vue?vue&type=script&lang=js&"
export * from "./Deploy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports